/* Author: Vaishnavi
Date: 19/11/2019
Issue NO:-
Description: Import UDF giving 500 error during Create & fetch url issue, Spacing issues fixed as per design guidelines
*/
/*
Author: Shivakumar
Date: 06/12//2019
Issue Description: Error message should not be displayed by default.
search_string: PL-2044
*/
/*
Author: Shivakumar
Date: 06/12//2019
Issue Description: Error message should not be displayed by default.
search_string: PL-2252
*/

/*
Author: Vinod
Date: 03/02//2020
Issue Description: While Creating Udf, Without selecting Criteria field unable to add the UDF.
search_string: PL_2606
*/

/*
Author: Vinod
Date: 11/03/2020
Issue Description:In Applicability Criteria Employee should be replaced with Employee categories.
search_string: PL_2914
*/

/*
Author: Vinod
Date: 11/03/2020
Issue Description: Able to Select multiple values in the Sub Criteria drop down.
search_string: PL_2915
*/

/*
Author: Vinod
Date: 16/03/2020
Issue Description: Need to remove Display in payslip.
search_string: PL_2933
*/
/*
Author: Vinod
Date: 16/03/2020
Enancement Description: With out adding the Criteria & subcriteria not able to add UDFs.
search_string: PL_2940
*/

/*
Author: Vinod
Date: 19/03/2020
Enancement Description: By default "TypeError: Cannot read property 'length' of undefined" Error message is displaying when we click on Misc.
search_string: PL_2956
*/

/*
Author: Vinod
Date: 02/04/2020
Enancement Description: While Creating UDF, without sub Criteria Getting error message as TypeError: Cannot read property 'map' of null.
search_string: PL_3005
*/
/*
Author: Vinod
Date: 02/04/2020
Enancement Description:  The values should be yes/no instead of true/false for the udf created.
search_string: PL_3006
*/

<template>
  <div class="udfDetails">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <h3 class="import-udf">Import UDF</h3>
    <div class="udfFields" v-show="ifTeamleaderPermission">
      <tl-radio
        name="uploadType"
        label="Bulk Upload"
        id="gender1"
        value="bulkUpload"
        v-model="uploadType"
      />
      <!-- <tl-radio
        name="uploadType"
        label="Manual"
        id="gender2"
        value="manualUpload"
        v-model="uploadType"
      /> -->
    </div>
    <div v-if="uploadType == 'bulkUpload'" v-show="ifTeamleaderPermission">
      <!-- <download-button
        class="margin-l-m margin-t-m"
        onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-%2BUDF.xlsx'"
      ></download-button> -->
      <download-button class="margin-l-m margin-t-m" @downloadTemplate="downloadTemplate()"></download-button>
      <div class="margin-t-m" :key="componentKey">
        <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
      </div>
    </div>
    <div class="margin-t-l" v-else>
      <div class="row" v-show="ifTeamleaderPermission">
        <!-- <div class="col-3">
          <tl-select
            name="Criteria"
            id="Criteria"
            label="Applicability Criteria"
            labelText="name"
            :options="criteriaArray"
            v-model="formData.criteriaObj"
            @change="(val) => {subCriteriaLabel=val.name; changeCriteria(val);}"
          />
        </div> -->
        <div class="col-3" v-if="subCriteriaLabel">
          <!-- PL_2915 -->
          <tl-select
            name="SubCriteria"
            id="SubCriteria"
            :label="subCriteriaLabel"
            labelText="name"
            :multiple="subCriteriaLabel == 'Employee Categories & Sub Categories' ? false:true"
            :options="subCriteriaArray"
            v-model="formData.subCriteriaObj"
            @change="(val) => changeSubCriteria(val)"
          />
        </div>
        <div class="col-3" v-if="subCriteriaLabel == 'Employee Categories & Sub Categories'">
          <tl-select
            name="SubCriteria"
            id="SubCriteria"
            label="Sub Categories"
            labelText="name"
            :options="subCategoryList"
            v-model="formData.subcategoryObj"
            @change="(val)=> {formData.subcategoryObj = val; }"
          />
        </div>
        <div class="col-2" v-if="subCriteriaLabel == 'Employee Categories & Sub Categories'">
          <btn type="secondary" text="Add Tag" @click="addTags()"></btn>
        </div>
        <div class="col-12" v-if="tagsArray.length>0">
          <div class="selectedComp">
            <div v-for="(data,index) in tagsArray" :key="index">
              <div class="rect">
                <button>
                  <span
                    v-if="data.subCategory"
                  >{{ data.category }}&nbsp; &bull; &nbsp;{{ data.subCategory }}</span>
                  <span v-else>{{ data.category }}</span>
                  <img src="@/assets/cross.svg" @click="removeTag(data.id, index)" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row margin-tb-m" v-show="ifTeamleaderPermission">
        <div class="col-12">
          <txt
            label="Enter User Defined Field *"
            type="text"
            v-model="formData.udf"
            name="userDefinedField"
            data-vv-as="user defined"
            v-validate="'required'"
            :classname="errors.has('userDefinedField')"
            :errormsg="errors.first('userDefinedField')"
            onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode > 47 && event.charCode < 58)"
          />
        </div>
      </div> -->

      <div v-show="ifTeamleaderPermission">
        <!-- <tl-checkbox
          class="margin-l-15px margin-b-m"
          label="Display In ESS"
          v-model="formData.displayInEss"
        /> -->
        <tl-checkbox
          v-if="formData.displayInEss"
          class="margin-l-45px margin-b-m"
          label="Editable By Employee"
          v-model="formData.editableByEmp"
        />
        <!-- PL_2933 -->
        <!-- <tl-checkbox
          class="margin-l-15px margin-b-m"
          label="Display In Payslip"
          v-model="formData.displayInPayslip"
        />-->
        <!-- <tl-checkbox
          class="margin-l-15px margin-b-m"
          label="Display In Report"
          v-model="formData.displayInReport"
        /> -->
        <!-- <button class="addBtn margin-t-25px" @click="addUdfData">Add</button> -->
      </div>
      <!-- <data-table
        v-show="showUdfTable || udfTableData"
        :columns="udfColumns"
        :tableData="udfTableData"
        :checkbox="false"
        :withForm="false"
        :showinrow="true"
        :showedit="false"
        :showhistory="false"
        @delete="deleteItem"
         :disabled="!(ifTeamleaderPermission)"
      /> -->
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`User Defined field has been successfully ${editMode ? 'updated' : 'created'}`"
        :popupType="'Success'"
        :closable="false"
        btnText="Back To Misc"
        @back="backFromPopup()"
      />
    </div>

    <pop-up-message
      v-if="showSuccessBulkUploadMsg"
      :message="responseMsg"
      btnText="Back To Misc"
      @back="backFromPopup()"
    ></pop-up-message>

    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure you want to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>

    <bottom-action-container>
      <btn-skip @navClicked="$emit('skip')" />
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="next" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { api_variables } from "@/apis/variables.js";

export default {
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_IMPORT_UDF_UPLOAD_TEMPLATE,
      popupType: "ConfirmDelete",
      currentObj: {},
      showConfirmDelete: false,
      responseMsg: "",
      componentKey: 0,
      subCriteriaLabel: "", //PL_2915
      showSuccessBulkUploadMsg: false,
      criteriaArray: [
        { name: "Location" },
        { name: "Salary Band" },
        { name: "Grade" },
        { name: "Cost Centre" },
        { name: "BUs" },
        { name: "Employee Categories & Sub Categories" }
      ],
      subCriteriaArray: [],
      subCategoryList: [], // PL_2914
      tagsArray: [], //PL_2914
      showBtn: true,
      uploadType: "bulkUpload",
      toast: false,
      formData: {
        udf: "",
        displayInEss: false,
        // displayInPayslip: false,     // PL_2933
        displayInReport: false,
        editableByEmp: false,
        criteriaObj: null,
        subCriteriaObj: [], // PL_2914
        subcategoryObj: null // PL_2914
      },
      udfTableData: [],
      // PL_2914
      udfColumns: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Criteria",
          key: "criteria"
        },
        {
          label: "Sub Criteria",
          key: "sub_criteria"
        },
        {
          label: "Display In ESS",
          key: "display_ess"
        },
        {
          //PL-2252
          label: "Editable by Employee",
          key: "isEditableByEmployee"
          //PL-2252
        },
        // PL_2933
        // {
        //   label: "Display In Payslip",
        //   key: "display_payslip"
        // },
        {
          label: "Display In Report",
          key: "display_report"
        }
      ],
      showUdfTable: false,
      showSuccessMsg: false,
      errmsg: "",
      miscValue: false,
      role: ""
    };
  },
  mounted() {
    // this.fetchAll();
    this.getOrgLeIdList();
  },
  activated() {
    this.refresh();
    // this.fetchAll();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState("onboard/importUdf", {
      udfData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),

    ...mapState({
      business_units: state => state.onboard.business_units.data,
      salary_bands: state => state.onboard.salary_bands.data,
      locations: state => state.onboard.locations.data,
      salary_grades: state => state.onboard.salary_grades.data,
      cost_centres: state => state.onboard.cost_centres.data,
      employeeCategories: state => state.onboard.empCategory.data // PL_2914
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      } else {
        return this.getleid(0);
      }
    },
    isLoading() {
      return this.isFetching;
    },
    editMode() {
      return this.$store.getters["onboard/importUdf/editMode"];
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.miscValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.miscValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },

  methods: {
    ...mapActions({
      act_fetchAll: "onboard/importUdf/fetchAll",
      act_update: "onboard/importUdf/update",
      act_create: "onboard/importUdf/create",
      act_delete: "onboard/importUdf/delete",
      act_upload_template: "onboard/importUdf/uploadTemplate",
      act_fetch_empCategories: "onboard/empCategory/fetchAll",
      act_fetch_locations: "onboard/locations/fetchAll",
      act_fetch_salary_bands: "onboard/salary_bands/fetchAll",
      act_fetch_grades: "onboard/salary_grades/fetchAll",
      act_fetch_cost_centers: "onboard/cost_centres/fetchAll",
      act_fetch_business_units: "onboard/business_units/fetchAll",
      act_download_template: "onboard/importUdf/downloadTemplate",
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

     /* function to upload excel file for bulk upload*/
    async onUploadTemplate(res) {
      try {
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.componentKey += 1;
            this.showSuccessBulkUploadMsg = true;
            // this.fetchAll();
          } else {
            this.toast = true;
            this.errmsg = res.response.data.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
        this.componentKey += 1;
      }
    },

    /* function to hide success pop-up */
    backFromPopup() {
      this.showSuccessMsg = false;
      this.showUdfTable = true;
      this.showSuccessBulkUploadMsg = false;
    },

    /* function to get subcriteria list based on selected criteria */
    changeCriteria(event) {
      try {
        if (event) {
          this.subCriteriaArray = [];
          this.subCategoryList = [];
          this.tagsArray = [];
          this.formData.criteriaObj = event;
          this.formData.subCriteriaObj = null;
          this.formData.subcategoryObj = null;
          if (event.name == "Location") {
            this.subCriteriaArray = this.locations[this.le_id]
              ? this.locations[this.le_id]
              : [];
          } else if (event.name == "Salary Band") {
            this.subCriteriaArray = this.salary_bands[this.le_id]
              ? this.salary_bands[this.le_id]
              : [];
          } else if (event.name == "Grade") {
            this.subCriteriaArray = this.salary_grades[this.le_id]
              ? this.salary_grades[this.le_id]
              : [];
          } else if (event.name == "Cost Centre") {
            this.subCriteriaArray = this.cost_centres[this.le_id]
              ? this.cost_centres[this.le_id]
              : [];
          } else if (event.name == "BUs") {
            this.subCriteriaArray = this.business_units.data
              ? this.business_units.data
              : [];
          } else if (event.name == "Employee Categories & Sub Categories") {
            // PL_2914
            this.subCriteriaArray = this.employeeCategories.length
              ? this.employeeCategories
              : [];
          }

          if (this.subCriteriaArray.length == 0) {
            this.getSubCriteriaList(event.name);
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get data from server of criteria if subcriteria list is empty */
    getSubCriteriaList(eventName) {
      switch (eventName) {
        case "Location":
          this.getLocations();
          break;
        case "Salary Band":
          this.getSalaryBands();
          break;
        case "Grade":
          this.getGrades();
          break;
        case "Cost Centre":
          this.getCostCenters();
          break;
        case "BUs":
          this.getBusinessUnits();
          break;
        case "Employee Categories & Sub Categories":
          this.empCategoryList();
          break;
      }
    },

    /* server call to get locations */
    async getLocations() {
      try {
        let res = await this.act_fetch_locations(this.le_id);
        this.subCriteriaArray = this.locations[this.le_id]
          ? this.locations[this.le_id]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get salary bands */
    async getSalaryBands() {
      try {
        let res = await this.act_fetch_salary_bands(this.le_id);
        this.subCriteriaArray = this.salary_bands[this.le_id]
          ? this.salary_bands[this.le_id]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get grades */
    async getGrades() {
      try {
        let res = await this.act_fetch_grades(this.le_id);
        this.subCriteriaArray = this.salary_grades[this.le_id]
          ? this.salary_grades[this.le_id]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get cost centres */
    async getCostCenters() {
      try {
        let res = await this.act_fetch_cost_centers(this.le_id);
        this.subCriteriaArray = this.cost_centres[this.le_id]
          ? this.cost_centres[this.le_id]
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* server call to get BUs */
    async getBusinessUnits() {
      try {
        let res = await this.act_fetch_business_units(this.le_id);
        this.subCriteriaArray = this.business_units.data
          ? this.business_units.data
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    // PL_2914

    /* server call to get employee categories */
    async empCategoryList() {
      try {
        let res = await this.act_fetch_empCategories(this.le_id);
        this.subCriteriaArray = res.data.payload.data;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to get sub-category of selected employee category */
    changeSubCriteria(event) {
      if (event) {
        if (
          this.formData.criteriaObj.name ==
          "Employee Categories & Sub Categories"
        ) {
          this.subCategoryList = event.subCategory ? event.subCategory : []; // PL_2914
        }
        this.formData.subCriteriaObj = event;
      }
    },
    // Start PL_2914

    /* function to add employee category tags after selection */
    addTags() {
      try {
        if (this.formData.subCriteriaObj && this.formData.subCriteriaObj.id) {
          let obj = {
            id: this.formData.subCriteriaObj.id,
            category: this.formData.subCriteriaObj.name,
            subCategory: this.formData.subcategoryObj
              ? this.formData.subcategoryObj.name
              : ""
          };
          if (
            !this.tagsArray.some(
              item => item.id == obj.id && item.subCategory == obj.subCategory
            )
          ) {
            if (this.subCategoryList.length) {
              if (this.formData.subcategoryObj) {
                this.toast = false;
                this.tagsArray.push(obj);
              } else {
                this.toast = true;
                this.errmsg = "Plese select sub-category!";
              }
            } else {
              this.toast = false;
              this.tagsArray.push(obj);
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to remove employee category tags */
    removeTag(val, index) {
      this.tagsArray.splice(index, 1);
    },
    // End PL_2914

    /* function to validate form */
    addUdfData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.create();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    /* server call to get UDFs */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        this.udfTableData = [];
        if (res.data.status) {
          for (var i = 0; i < res.data.payload.data.length; i++) {
            if (this.le_id == res.data.payload.data[i].le_id) {
              let obj = {
                id: res.data.payload.data[i].id,
                name: res.data.payload.data[i].name,
                criteria: res.data.payload.data[i].criteria
                  ? res.data.payload.data[i].criteria.type
                  : "",
                sub_criteria: this.getSubCatgoris(
                  res.data.payload.data[i].criteria // PL_2914
                ),
                display_ess: res.data.payload.data[i].display_ess ? "Yes": "No",   // PL_3006
                // display_payslip: res.data.payload.data[i].display_payslip,     // PL_2933
                display_report: res.data.payload.data[i].display_report ? "Yes": "No", // PL_3006
                editableByEmp: res.data.payload.data[i].editable_by_employee ? "Yes": "No", // PL_3006
                //PL-2252
                isEditableByEmployee:
                  res.data.payload.data[i].isEditableByEmployee ? "Yes": "No" // PL_3006
                //PL-2252
              };
              this.udfTableData.push(obj);
            }
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    // PL_2914

    /* function to get selected sub categories to show in table */
    getSubCatgoris(data) {
      try {
        if (data && data.value && data.value.length) {     // PL_2956
          if (data.type == "Employee Categories & Sub Categories") {
            return data.value
              .map(item => {
                return item.category + "(" + item.subCategory + ")";
              })
              .toString();
          } else {
            return data.value
              .map(item => {
                return item.name;
              })
              .toString();
          }
        } else {
          return "";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to go to next step */
    next() {
      this.$emit("next");
    },


    /* server call to submit the form data */
    async create() {
      try {
        // Start PL_2914
        let criteriaData = null;
        if (this.formData.criteriaObj) {
          // PL_2940
          if (
            this.formData.criteriaObj.name ==
            "Employee Categories & Sub Categories"
          ) {
            criteriaData = {
              type: this.formData.criteriaObj.name,
              value: this.tagsArray
            };
          } else {
            criteriaData = {
              type: this.formData.criteriaObj.name,
              value: this.formData.subCriteriaObj ? this.formData.subCriteriaObj.map(item => {
                return { id: item.id, name: item.name };
              }) : []   // PL_3005
            };
          }
        }
        // End PL_2914
        let obj = {
          data: {
            le_id: this.le_id,
            name: this.formData.udf.toString().trim(),
            display_ess: this.formData.displayInEss,
            // display_payslip: this.formData.displayInPayslip,     // PL_2933
            display_report: this.formData.displayInReport,
            isEditableByEmployee: this.formData.editableByEmp,
            criteria: criteriaData
          }
        };
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj);
        setTimeout(() => {
          if (res) {
            if (res.data.status) {
              this.showSuccessMsg = true;
              this.refresh();
            }
          }
          this.fetchAll();
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to open delete confirmation pop-up */
    deleteItem(item) {
      try {
        this.showConfirmDelete = true;
        this.currentObj = item;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to close delete confirmation pop-up */
    cancelEvent() {
      this.showConfirmDelete = false;
    },

    /* server call to delete the item */
    async deleteEvent() {
      try {
        let res = await this.act_delete({ id: this.currentObj.id });
        this.fetchAll();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.showConfirmDelete = false;
    },

    /* function to refresh the page */
    refresh() {
      try {
        this.subCriteriaLabel = "";
        this.tagsArray = [];
        this.formData = {
          udf: "",
          displayInEss: false,
          displayInPayslip: false,
          displayInReport: false,
          editableByEmp: false,
          criteriaObj: null,
          subCriteriaObj: [],
          subcategoryObj: null
        };
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.miscValue = data.data.user.permissions.misc ? true : false;
      //console.log("PL-3406",data);
    },

    async downloadTemplate() {
      try {
      let data={
          le_id : this.le_id,
          org_id: this.orgIds,
        }
        let res = await this.act_download_template(data);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/components/margins.scss";

.udfFields {
  margin-top: 38px;
  margin-left: 20px;
  display: flex;
}

.addBtn {
  width: 95px;
  height: 35px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #37c6c0;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #37c6c0;
  margin-left: 20px;
  margin-bottom: 32px;
}

.udfDetails {
  margin-bottom: 110px;
}

.selectedComp {
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
}
.rect {
  padding: 10px 20px 10px 20px;
  margin: 2px;
  border-radius: 21px;
  background-color: #c7efef;
  text-align: center;
  img {
    padding-left: 10px;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
.import-udf{
  margin-top: 60px;
  color: #6e6e6e;
}
</style>
